import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Skeleton, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import AcceptanceList from "./AcceptanceList";
import GuaranteeList from "./GuaranteeList";
import Overview from "./Overview";
import WarrantyList from "./WarrantyList";
import useMeta from "./useMeta";
import "./warranty.css";

const TABS = ["overview", "acceptances", "warranties", "guarantees"];

/**
 * The tabs of the module: overview, acceptance protocols, warranties, guarantee bonds. Used as
 * the page /user/warranty and, with `project`, as the tab on a project's page.
 */
export const WarrantyTabs = ({ project, routed = false }) => {
  const { t } = useTranslation("dashboard");
  const history = useHistory();
  const location = useLocation();
  const [meta, reloadMeta] = useMeta();
  const params = new URLSearchParams(location.search);
  const [localTab, setLocalTab] = React.useState("overview");
  const tab = routed
    ? TABS.includes(params.get("tab"))
      ? params.get("tab")
      : "overview"
    : localTab;
  const guarantee = routed ? params.get("guarantee") : null;

  const go = (next, extra = {}) => {
    if (!routed) {
      setLocalTab(next);
      return;
    }
    const query = new URLSearchParams({ tab: next, ...extra });
    history.replace(`${location.pathname}?${query.toString()}`);
  };

  if (!meta) return <Skeleton active paragraph={{ rows: 8 }} />;

  return (
    <Tabs
      activeKey={tab}
      onChange={key => go(key)}
      destroyInactiveTabPane
      items={[
        {
          key: "overview",
          label: t("Overview"),
          children: (
            <Overview
              project={project}
              canUpdate={meta.can.update}
              onOpenGuarantee={id => go("guarantees", { guarantee: id })}
            />
          )
        },
        {
          key: "acceptances",
          label: t("Acceptances"),
          children: <AcceptanceList meta={meta} project={project} />
        },
        {
          key: "warranties",
          label: t("Warranties"),
          children: <WarrantyList meta={meta} project={project} />
        },
        {
          key: "guarantees",
          label: t("Guarantee bonds"),
          children: (
            <GuaranteeList
              meta={meta}
              project={project}
              openId={guarantee}
              onMetaChanged={reloadMeta}
            />
          )
        }
      ]}
    />
  );
};

const Warranty = () => (
  <div className="warranty-page">
    <WarrantyTabs routed />
  </div>
);

export default Warranty;
